var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.25.25h17.5v23.461l-8.717-8.034L3.25 23.7V.25Z","clip-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }